import { render, staticRenderFns } from "./LactoseAbsorption.vue?vue&type=template&id=cb83a1bc"
import script from "./LactoseAbsorption.vue?vue&type=script&lang=js"
export * from "./LactoseAbsorption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports